import { render } from "./product-addons.vue?vue&type=template&id=5e328c8a"
import script from "./product-addons.vue?vue&type=script&lang=js"
export * from "./product-addons.vue?vue&type=script&lang=js"

import "./product-addons.vue?vue&type=style&index=0&id=5e328c8a&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__